<script lang="ts">
  // Import components
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import { pageMainColor, headerVariant } from "$stores";
  import { getContext } from "svelte";
  import { setAppContext } from "$lib/utils/contexts";
  import Footer from "$lib/views/Footer.svelte";

  // Import types
  import type {
    AnchorLinkWithCssClassStoryblok,
    NavItemStoryblok,
    SocialLinkStoryblok,
  } from "$types/components";

  // Get the block data
  export let blok;

  // Set the page type
  setAppContext("pageType", "consumer-home-page");

  // Set the header variant and unset the page color
  headerVariant.set("transparent-light");
  pageMainColor.set("");

  // Get the footer data
  const categories = undefined;
  const navigation = getContext("footerNavigation") as NavItemStoryblok[];
  const socials = getContext("socials") as SocialLinkStoryblok[];
  const footerBottomLinks = getContext("footerBottomLinks") as AnchorLinkWithCssClassStoryblok[];
</script>

<div class="hero-wrapper">
  {#each [...(blok.hero ?? [])] as heroBlok}
    <StoryblokComponent blok={heroBlok} />
  {/each}

  <div class="clouds-background"></div>
</div>

<div class="body-wrapper">
  {#each [...(blok.body ?? [])] as bodyBlok}
    <StoryblokComponent blok={bodyBlok} />
  {/each}
</div>

<Footer {categories} {navigation} {socials} {footerBottomLinks} backgroundColor="charcoal" />

<style lang="postcss">
  .hero-wrapper {
    position: relative;
    height: 100%;
    margin: 0 auto;
    margin-top: -68px;
    overflow: hidden;
  }

  .clouds-background {
    position: absolute;
    top: 80vh;
    width: 100%;
    height: 100%;
    background-image: url("/images/home/howitworks/background-clouds-mobile.webp");
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: cover;
    z-index: -1;

    @screen md {
      top: 600px;
    }

    @screen lg {
      background-image: url("/images/home/howitworks/background-clouds-desktop.webp");
    }
  }

  .body-wrapper {
    margin: 0 auto;
  }
</style>
